import type { SSOClientConfig } from './types'
import { ssoStorage } from './ssoStorage'

export const DEFAULT_OAUTH_SCOPES = ['openid', 'email', 'profile']

/**
 * Returns the SSO client config resolved at landing time from the BFF
 * registry and persisted in the SSO context. There is no local fallback —
 * the server registry is the source of truth.
 */
export const getSSOClientConfig = (): SSOClientConfig | undefined => {
  return ssoStorage.getContext()?.resolvedConfig
}
